import { render } from "./AddAdminUserB2B.vue?vue&type=template&id=69a01074&scoped=true"
import script from "./AddAdminUserB2B.vue?vue&type=script&lang=js"
export * from "./AddAdminUserB2B.vue?vue&type=script&lang=js"

import "./AddAdminUserB2B.vue?vue&type=style&index=0&id=69a01074&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a01074"]])

export default __exports__